<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    overlay-color="black"
    class="dialog-image"
  >
    <template v-slot:activator="{ on, attrs }">
      <img :src="img" class="message-image" v-bind="attrs" v-on="on" />
    </template>

    <img :src="img" class="message-full-image" />
  </v-dialog>
</template>

<script>
export default {
  props: {
    img: String
  },
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style lang="scss">
.v-dialog {
  box-shadow: none !important;
}
.message-image {
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
}
.message-full-image {
  max-width: 500px;
  object-fit: contain;
  max-height: 80vh;
}
</style>
